import { render, staticRenderFns } from "./IresConfiguration.vue?vue&type=template&id=17f7702e&scoped=true&"
import script from "./IresConfiguration.vue?vue&type=script&lang=ts&"
export * from "./IresConfiguration.vue?vue&type=script&lang=ts&"
import style0 from "./IresConfiguration.vue?vue&type=style&index=0&id=17f7702e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f7702e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VProgressCircular,VRow})
